import enMessages from './en.json'
import frMessages from './fr.json'
import roMessages from './ro.json'
import zhMessages from './zh.json'

// Inserire qui i domini d'applicazione di dove è richiesto effettivamente il mapping inverso
export const DOMAINS = {
    CLIPCARDKM: ['COLLECTION_END', 'PLAYER_OFF', 'SKILL_CROSS', 'MISS', 'TACKLE', 'SKILL_GOAL', 'SKILL_DRIBBLING',
        'START', 'KB_CONFIRMED_AFTER_REVIEW', 'SKILL_ASSIST', 'SKILL_HEAD', 'SAVE', 'SKILL_SET_PIECE', 'SKILL_SHOT',
        'GOAL', 'SKILL_GOAL_FRAME', 'SKILL_TACKLE', 'PASS', 'END', 'DELETED_AFTER_REVIEW', 'CARD', 'SKILL_PASS', 'SKILL_SAVE'
    ]
}

const messagesLocale = {
    en: enMessages,
    fr: frMessages,
    ro: roMessages,
    zh: zhMessages,
}

/*
* Del locale preso in considerazione, restituisce l'insieme delle chiavi corrispondenti al valore, altrimenti, in caso di mancata presenza del valore in locale e/o
* il valore che è già chiave, allora restituisce direttamente la stringa value

function getReverseGlobalValue (value, locale = 'en') {
    // Sicurezza: se value è vuoto o non è una stringa, lo restituiamo
    if (!value || typeof value !== 'string') return value;

    // Vediamo se è chiave
    if(messagesLocale[locale][value] !== undefined && messagesLocale[locale][value] !== null)
        return value;

    // Se non è chiave prendo tutte le chiavi che hanno quel valore corrispondente
    const keysOfValue = Object.keys(messagesLocale[locale]).filter(keyOfMessageLocale => keyOfMessageLocale === value)

    return keysOfValue.length === 0 ? value : keysOfValue
}

 */


/*
* rgv è il risultato di reverseglobalvalue
* value è sempre quello iniziale
* domainName è il NOME del dominio d'applicazione (es. 'CLIPCARDKM')
* locale è il proprio locale (fallback in 'en' come sempre)
*
* Se il risultato di rgv è una stringa, allora bisogna lasciarla perdere e restituirla direttamente perchè o custom o è chiave già
* Se il risultato di rgv è un array allora bisogna vedere se c'è almeno una delle chiavi di rgv che fa parte del dominio:
*   - Se c'è almeno una delle chiavi che fa parte del dominio allora si prende la prima corrispondente
*   - Se non c'è alcuna chiave che fa parte del dominio allora si prende a prescindere la prima disponibile
* Questa funzione è per avere il reverse A PRESCINDERE. SI RESTITUISCE IL VALORE SOLO SE SI È CERTI DEL FATTO CHE È UNA CHIAVE O UN VALORE CUSTOM

* *



export function getReverseParseValueByDomain (value, domain, locale = 'en') {
    const rgv = getReverseGlobalValue(value, locale)

    // Caso in cui fa parte del dominio
    if(typeof rgv === 'string')
        return rgv

    // Prendiamo il dominio corrispondente
    const domainKeys = DOMAINS[domain] || []

    // Retrieve delle chiavi che fanno parte del dominio
    const keysInDomain = rgv.filter(el => domainKeys.includes(el))

    // Se non ci sono chiavi nel dominio, restituire la prima disponibile, altrimenti la prima che fa parte del dominio
    return keysInDomain.length === 0 ? rgv[0] : keysInDomain[0]
}
*/

export function getKeyByValueMapping (value, locale = 'en') {
    // Vediamo se è chiave
    if(messagesLocale[locale][value] !== undefined && messagesLocale[locale][value] !== null)
        return value;

    // Se non è chiave prendo tutte le chiavi che hanno quel valore corrispondente
    const keysOfValue = Object.keys(messagesLocale[locale]).filter(keyOfMessageLocale => messagesLocale[locale][keyOfMessageLocale] === value)

    // Restituisco o il valore se non ci sono keys corrispondenti oppure la prima occorrenza tra le chiavi di quel valore corrispondente
    return keysOfValue.length === 0 ? value : keysOfValue[0]
}